import { FILTER_TYPE_CHILD_DESTINATIONS, FILTER_TYPE_DESTINATIONS } from '@/helpers/data-filter/DataFilterTypes';

/**
 *
 * @param {DataFilterHelper} filterHelper
 * @param groupsWithItems
 * @returns {[]|[undefined|{type: string, itemsType: *, title: *, items: *, opened: boolean, dependOn: null, useSelectAll: boolean},undefined|{type: string, itemsType: *, title: *, items: *, opened: boolean, dependOn: null, useSelectAll: boolean}]}
 */
export default function destinationGroupsResolver(filterHelper, groupsWithItems) {
  return filterHelper.addParentWithChildrenGroupItems(
    groupsWithItems,
    {
      parentKey: 'destinations',
      parentItemsType: FILTER_TYPE_DESTINATIONS,
    },
    { childrenItemsType: FILTER_TYPE_CHILD_DESTINATIONS, childrenTitle: 'Places' }
  );
}
